export default __webpack_public_path__ + "static/media/b.ea8530d5.png";